import moment from 'utils/moment';

const DATE_KEY = 'YYYY-MM-DD';

// Staff initials live with the shared avatar helpers; re-exported here so the
// Time Off formatters stay a single import surface.
export { initialsOf } from 'utils/staff-name';

/** 'YYYY-MM-DD' → 'Jul 8'. */
export const fmtShort = (key: string): string => moment(key, DATE_KEY).format('MMM D');

/** 'YYYY-MM-DD' → 'Wed, Jul 8, 2026'. */
export const fmtLong = (key: string): string => moment(key, DATE_KEY).format('ddd, MMM D, YYYY');

/** Minutes since midnight → '09:00 AM'. */
export const fmtTime = (min: number): string => {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return moment().hour(h).minute(m).format('hh:mm A');
};

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export const monthLabel = (year: number, month: number): string => `${MONTH_NAMES[month]} ${year}`;

/** Inclusive day span between two 'YYYY-MM-DD' keys. */
export const daysBetween = (start: string, end: string): number =>
  Math.round((moment(end, DATE_KEY).valueOf() - moment(start, DATE_KEY).valueOf()) / 86400000) + 1;

/** Date label for a range: single-day → long form; multi-day → 'Jul 10 – Jul 12, 2026'. */
export const rangeDateLabel = (start: string, end: string): string =>
  start === end ? fmtLong(start) : `${fmtShort(start)} – ${fmtShort(end)}, ${end.slice(0, 4)}`;

/**
 * Month range for a block-hours query, padded ±7d to catch month-boundary spans.
 * Date-only `YYYY-MM-DD` matches the format the existing range consumer sends to
 * the same endpoint (see apis.getBlockHoursByStaffId caller).
 */
export const monthRequestRange = (year: number, month: number): { startTime: string; endTime: string } => {
  const first = moment({ year, month, day: 1 });
  return {
    startTime: first.clone().subtract(7, 'days').format('YYYY-MM-DD'),
    endTime: first.clone().endOf('month').add(7, 'days').format('YYYY-MM-DD'),
  };
};
